import MathHelper from './MathHelper';

export default class ScaleHelper {
  static pieceScale(piece, scale = 1) {
    if (scale === 1) return piece;

    let { drillHoles, internalLines, notches, seam } = piece;

    const scalarMultiplicationPoint = (point) => MathHelper.scalarMultiplicationPoint(point, scale);

    if (drillHoles && Object.keys(drillHoles).length) {
      drillHoles = Object.assign(...Object.entries(drillHoles)
        .map(([k, v]) => ({ [k]: scalarMultiplicationPoint(v) })));
    }

    if (internalLines && Object.keys(internalLines).length) {
      internalLines = Object.assign(...Object.entries(internalLines)
        .map(([k, v]) => {
          const { startHandle, endHandle } = v;
          return {
            [k]: {
              ...v,
              startHandle: scalarMultiplicationPoint(startHandle),
              endHandle: scalarMultiplicationPoint(endHandle),
              knots: this.scaleKnots(v.knots, scale),
            },
          };
        }));
    }

    notches = notches ? notches.map((notch) => ({
      ...notch,
      distance: notch.distance * scale,
    })) : [];

    seam = seam ? seam.map((s) => ({
      ...s,
      allowance: s.allowance * scale,
    })) : [];

    return {
      ...piece,
      knots: this.scaleKnots(piece.knots, scale),
      drillHoles,
      internalLines,
      notches,
      seam,
    };
  }

  static scaleBezier(bezier, scale = 1) {
    if (scale === 1) return bezier;

    return {
      ...bezier,
      points: bezier.points.map((point) => MathHelper.scalarMultiplicationPoint(point, scale)),
    };
  }

  static scaleKnots(knots, scale = 1) {
    if (scale === 1) return knots;

    return knots.map((knot) => this.scaleKnot(knot, scale));
  }

  static scaleKnot(knot, scale = 1) {
    if (scale === 1) return knot;

    return {
      ...MathHelper.scalarMultiplicationPoint(knot, scale),
      lH: MathHelper.scalarMultiplicationPoint(knot.lH, scale),
      rH: MathHelper.scalarMultiplicationPoint(knot.rH, scale),
    };
  }

  static scaleTextBox(textBox, scale = 1) {
    if (scale === 1) return textBox;

    return {
      ...textBox,
      x: textBox.x * scale,
      y: textBox.y * scale,
      points: textBox.points * scale,
    };
  }

  static rulerScale(ruler, scale) {
    if (scale === 1) return ruler;

    const { startPoint, endPoint } = ruler;

    const scaledRuler = {
      ...ruler,
      startPoint: MathHelper.scalarMultiplicationPoint(startPoint, scale),
    };

    return endPoint ? { ...scaledRuler, endPoint: MathHelper.scalarMultiplicationPoint(endPoint, scale) } : scaledRuler;
  }

  static scaleProperties(object, properties, scale) {
    return properties.map((property) => object[property] * scale);
  }
}
